import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-paragraph",
  "use": "icon-paragraph-usage",
  "viewBox": "-53 0 426 426.66667",
  "content": "<symbol viewBox=\"-53 0 426 426.66667\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-paragraph\"><path d=\"m299 384h-42.667969v-341.332031h26.667969c11.777344 0 21.332031-9.539063 21.332031-21.335938s-9.554687-21.332031-21.332031-21.332031h-176c-58.816406 0-106.667969 47.851562-106.667969 106.667969 0 58.816406 47.851563 106.664062 106.667969 106.664062h42.667969v170.667969h-21.335938c-11.773437 0-21.332031 9.535156-21.332031 21.332031s9.558594 21.335938 21.332031 21.335938h170.667969c11.777344 0 21.332031-9.539063 21.332031-21.335938s-9.554687-21.332031-21.332031-21.332031zm-192-213.332031c-35.285156 0-64-28.714844-64-64 0-35.285157 28.714844-64 64-64h42.667969v128zm85.332031-128h21.335938v341.332031h-21.335938zm0 0\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/paragraph.svg
// module id = TYH+
// module chunks = 102